// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__VEEmw","btn":"ErrorPage_btn__hg+jz"};